import React from 'react';
import MemoryIcon from '@mui/icons-material/Memory';
import InputSearch from '../../components/InputSearch';
import LoadingSpinner from '../../components/LoadingSpinner';

const FirmwareVersions = ({ versions, loading = false, onSearch, searchDefaultValue = '', title = 'Актуальные версии прошивок' }) => {
  const hasVersions = Boolean(versions?.length);

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-md rounded-3xl p-4 mt-6">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-3">
            <MemoryIcon className="text-gray-500" />
            <h3 className="text-base sm:text-lg font-medium text-gray-700">{title}</h3>
          </div>
          {loading && !hasVersions ? (
            <LoadingSpinner loading={true} style="text-gray-300 p-1" />
          ) : hasVersions ? (
            <div className="flex flex-wrap gap-2">
              {versions.map(({ device_model, version }) => (
                <div
                  key={`${device_model}-${version}`}
                  className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-50 border border-gray-200 text-sm text-gray-700">
                  <span className="font-medium">{device_model} · </span>
                  <span className="text-primary-500">{version}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">Нет данных</p>
          )}
        </div>
        {onSearch && (
          <InputSearch
            prefix={<MemoryIcon className="text-gray-500" />}
            handleSearch={onSearch}
            defaultValue={searchDefaultValue}
            placeholder={'Поиск по серийному номеру...'}
            showReset={true}
            className={'lg:min-w-[280px] lg:max-w-[320px] w-full'}
          />
        )}
      </div>
    </div>
  );
};

export default FirmwareVersions;
